import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Contrast01 = function Contrast01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2c.5917 0 1.1713.0514 1.7348.15M12 2C6.4772 2 2 6.4772 2 12s4.4772 10 10 10m0-20v20m5.738-18.191a10.06 10.06 0 0 1 2.4554 2.4564m1.6567 4.0002C21.9486 10.8289 22 11.4085 22 12s-.0514 1.1711-.1499 1.7344m-1.6609 4.0062a10.06 10.06 0 0 1-2.4523 2.4511m-4.0041 1.6587A10.07 10.07 0 0 1 12 22"
    })
  }));
};
export default Contrast01;